import React, { ChangeEvent, memo } from 'react';
import styled, { css } from 'styled-components';
import theme from '@styles/theme';

type StyledCheckboxProps = {
    label?: string;
    margin?: string;
    width?: string;
    fontColor?: string;
    checkboxId?: string;
    value: any;
    name: string;
    checked: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const StyledCheckbox = ({
    label,
    margin,
    width,
    fontColor,
    checkboxId,
    value,
    name = 'checkbox',
    checked,
    onChange = () => null
}: StyledCheckboxProps) => {
    return (
        <Wrapper $margin={margin} $width={width}>
            <Box>
                <Input
                    id={checkboxId}
                    type="checkbox"
                    name={name}
                    value={value}
                    onChange={onChange}
                    checked={checked}
                />
                <Label
                    htmlFor={checkboxId}
                    $checked={checked}
                    $fontColor={fontColor}
                >
                    {label}
                </Label>
            </Box>
        </Wrapper>
    );
};

export default memo(StyledCheckbox);

const Wrapper = styled.div<{ $margin?: string; $width?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: ${({ $width }) => ($width ? $width : 'auto')};
`;
const Box = styled.div`
    position: relative;
    margin-right: 26px;
`;
const Label = styled.label<{
    $margin?: string;
    $checked?: boolean;
    $fontColor?: string;
}>`
    font-size: 14px;
    font-weight: 500;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.grayFontColor};
    padding-top: 2px;
    display: inline-block;
    margin-right: 4px;
    cursor: pointer;

    &:before {
        content: '';
        display: inline-block;
        top: 10px;
        right: -21px;
        vertical-align: top;
        -webkit-transition: -webkit-transform 0.4s
            cubic-bezier(0.45, 1.8, 0.5, 0.75);
        -moz-transition: -moz-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
        transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
        z-index: 1;
        width: 8px;
        height: 3px;
        border-top-style: none;
        border-right-style: none;
        border-bottom-style: solid;
        border-left-style: solid;
        border-color: ${theme.colors.whiteColor};
        border-width: 2px;
        position: absolute;
        cursor: pointer;
    }

    &:after {
        content: '';
        width: 20px;
        height: 20px;
        display: inline-block;
        position: absolute;
        margin-left: -20px;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
        right: -26px;
        top: 4px;
        border-radius: 10px;
        box-sizing: border-box;
        background-color: ${theme.colors.lightGrayFontColor};
    }

    ${({ $checked }) =>
        $checked &&
        css`
            &:after {
                background-color: ${theme.colors.pointGreen};
            }
        `}
`;
const Input = styled.input`
    position: absolute;
    opacity: 0;
    height: auto;
    z-index: -1;
`;
